<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20">
    <path id="icono-calendario" d="M18.5,12.5h-5v5h5Zm-1-11v2h-8v-2h-2v2h-1a1.991,1.991,0,0,0-1.99,2l-.01,14a2,2,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2V5.5a2.006,2.006,0,0,0-2-2h-1v-2Zm3,18H6.5V8.5h14Z" transform="translate(-4.5 -1.5)" :fill="color"/>
    </svg>
</template>
<script>
export default {
    props:{
        color:{
            type: String,
            default: '#89899B'
        },
        width:{
            type: String,
            default: '30'
        },
        height:{
            type: String,
            default: '25'
        }        
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/CalendarIcon.vue